import { render } from "./DocumentImportsView.vue?vue&type=template&id=a47370d4"
import script from "./DocumentImportsView.vue?vue&type=script&lang=js"
export * from "./DocumentImportsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__